import {getWindow, getDocument} from 'ssr-window';

export const ssr_window = getWindow()

export const ssr_document = getDocument()

export default {
  data() {
    return {
      resized_trigger: 0,
      window_innerHeight: ssr_window.innerHeight || 0,
      window_innerWidth: ssr_window.innerWidth || 0,
    }
  },
  mounted() {
    ssr_window.addEventListener('resize', this.resizeEvent)
  },
  methods: {
    resizeEvent({target}) {
      this.resized_trigger++
      this.window_innerHeight = target.innerHeight || 0
      this.window_innerWidth = target.innerWidth || 0
    },
    destroyResizeEvent() {
      ssr_window.removeEventListener('resize', this.resizeEvent)
    }
  },
  destroyed() {
    this.destroyResizeEvent()
  }
}
